import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { TSupportedLocales } from 'types';
import { AMPLITUDE_EVENTS } from './tracking.events';

export const trackPageVisited = (title: string, locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.introducerPortalVisited,
      locale: locale,
      payload: {
        'Page name': title,
        URL: window.location.pathname,
      },
    }),
  );
};
